module.exports = __webpack_public_path__ + "img/Tail_feathers_DiffuseColor.82653d0.png";